import { render, staticRenderFns } from "./NonconformanceTypes.vue?vue&type=template&id=6d2583b8"
import script from "./NonconformanceTypes.vue?vue&type=script&lang=js"
export * from "./NonconformanceTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports